import { useQuery } from '@tanstack/react-query'

import { scenarioResultsClient } from '@/api'
import { useDebouncedValue } from '@/hooks'
import { convertDateToLocal } from '@/utils'

export const useTimeSeriesChartData = (
  scenarioId: number,
  startDate?: Date
) => {
  const applyIncomeAdjustment = true
  const BASE_QUERY_KEY = [
    ...scenarioResultsClient.QUERY_KEY(scenarioId),
    'summary',
    { applyIncomeAdjustment }
  ]

  const scenarioQuery = useQuery({
    queryKey: BASE_QUERY_KEY,
    queryFn: () =>
      scenarioResultsClient.getResultsSummary(scenarioId, applyIncomeAdjustment)
  })

  const debouncedDate = useDebouncedValue<Date>(convertDateToLocal(startDate))

  const query = useQuery({
    queryKey: [...BASE_QUERY_KEY, 'chartData', { debouncedDate }],
    queryFn: () =>
      debouncedDate &&
      scenarioResultsClient.getChartData(scenarioId, debouncedDate),
    enabled: !!debouncedDate
  })

  return {
    isFetching: query.isFetching,
    timeSeriesData: query.data || [],
    scenarioConfiguration: scenarioQuery.data?.systemConfiguration
  }
}
